<template>
  <v-menu origin="top right" transition="scale-transition" offset-y bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" class="mr-n3" color="primary" v-on="on" elevation="0" outlined small>
        <span class="caption">
          {{ $t('hausefulInvoices.filters.title') }}
        </span>
        <v-icon right small>
          mdi-filter-outline
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item class="px-5 py-2">
        <FilterDates
          :fetchData="fetchHausefulTakeRateInvoices"
          :label="$t('hausefulInvoices.filters.emissionDate')"
          startDateProp="startDate"
          endDateProp="endDate"
          dateRange
        />
      </v-list-item>
      <v-list-item class="px-5 py-2">
        <FilterDates
          :fetchData="fetchHausefulTakeRateInvoices"
          :label="$t('hausefulInvoices.filters.createDate')"
          startDateProp="creationStartDate"
          endDateProp="creationEndDate"
          filterName="creationDate"
          dateRange
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'

import { mapActions } from 'vuex'

export default {
  name: 'HausefulTakeRateInvoicesFilters',

  components: { FilterDates },

  methods: {
    ...mapActions(['fetchHausefulTakeRateInvoices']),
  },
}
</script>
